export default __webpack_public_path__ + "static/media/poke-search.d769f471.jpg";